import {BrowserRouter as Router, Routes, Route, useNavigate} from 'react-router-dom';

import {Index} from './views';
import {Nosotros} from './views/Nosotros';
import {Servicios} from './views/Servicios';
import {AnalisisCredito} from './views/AnalisisCredito';
import {Pld} from './views/Pld';
import {Dispersion} from './views/Dispersion';
import {Cobranza} from './views/Cobranza';
import {CardEmision} from './views/CardEmision';
import {LockPhone} from './views/LockPhone';
import {PayServices} from './views/PayServices';
import {CampaignNoti} from './views/CampaignNoti';
import {Scoring} from './views/Scoring';
import {Beneficios} from './views/Beneficios';
import {NotFound} from './views/NotFound';
import {Contact} from './views/Contact';
import {AvisoPrivacidad} from './views/AvisoPrivacidad';
import {TerminosCondiciones} from './views/TerminosCondiciones';
import {ThanksView} from './views/ThanksView';
import {SiteMap} from './views/SiteMap';
import {UseCases} from './views/UseCases';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

//import { Webinar } from './views/Webinar';

const RedirectWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname } = window.location;
    
    // Elimina la barra del ginal
    if (pathname.endsWith('/')) {
      navigate(pathname.slice(0, -1), { replace: true });
      return; //terminar si se redirecciona
    }

    //logica de rtedireccion conforme al idioma
    const languagePrefix = i18n.language === 'en' ? '/en' : '';
    const currentLanguagePrefix = pathname.startsWith('/en') ? '/en' : '';

    if (currentLanguagePrefix !== languagePrefix) {
      const newPathname = `${languagePrefix}${pathname.replace(/^\/en/, '')}`;
      navigate(newPathname, { replace: true });
    }
     

  }, [i18n.language, navigate]);

  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <RedirectWrapper>
      <Routes>
        {/* url in english */}
        
        <Route path='/' element={ <Index />} />
        <Route path='/en/nosotros' element={ <Nosotros />} />
        <Route path='/en/beneficios' element={ <Beneficios />} />
        <Route path='/en/onboarding' element={ <Servicios />} />
        <Route path='/en/analisis-crediticio' element={ <AnalisisCredito />} />
        <Route path='/en/pld' element={ <Pld />} />
        <Route path='/en/dispersion-pagos' element={ <Dispersion />} />
        <Route path='/en/cobranza' element={ <Cobranza />} />
        <Route path='/en/emision-tarjetas' element={ <CardEmision />} />
        <Route path='/en/bloqueo-dispositivos' element={ <LockPhone />} />
        <Route path='/en/pago-servicios' element={ <PayServices />} />
        <Route path='/en/notificaciones' element={ <CampaignNoti />} />
        <Route path='/en/score-alternativo' element={ <Scoring />} />
        <Route path='/en/caso-de-uso-credito' element={ <UseCases />} />
        <Route path='/en/sitemap' element={ <SiteMap />} />
        <Route path='/en/contacto' element={ <Contact />} />
        <Route path='/en/gracias' element={ <ThanksView/> } />
        <Route path='/en/aviso-de-privacidad' element={ <AvisoPrivacidad />} />
        <Route path='/en/terminos-y-condiciones' element={ <TerminosCondiciones />} />
        <Route path='/en/*' element={ <NotFound />} />
        
        

        {/* url en español*/}
        <Route path='/' element={ <Index />} />
        <Route path='/nosotros' element={ <Nosotros />} />
        <Route path='/beneficios' element={ <Beneficios />} />
        <Route path='/onboarding' element={ <Servicios />} />
        <Route path='/analisis-crediticio' element={ <AnalisisCredito />} />
        <Route path='/pld' element={ <Pld />} />
        <Route path='/dispersion-pagos' element={ <Dispersion />} />
        <Route path='/cobranza' element={ <Cobranza />} />
        <Route path='/emision-tarjetas' element={ <CardEmision />} />
        <Route path='/bloqueo-dispositivos' element={ <LockPhone />} />
        <Route path='/pago-servicios' element={ <PayServices />} />
        <Route path='/notificaciones' element={ <CampaignNoti />} />
        <Route path='/score-alternativo' element={ <Scoring />} />
        <Route path='/caso-de-uso-credito' element={ <UseCases />} />
        <Route path='/sitemap' element={ <SiteMap />} />
        <Route path='/contacto' element={ <Contact />} />
        <Route path='/gracias' element={ <ThanksView/> } />
        <Route path='/aviso-de-privacidad' element={ <AvisoPrivacidad />} />
        <Route path='/terminos-y-condiciones' element={ <TerminosCondiciones />} />
        <Route path='*' element={ <NotFound />} />
        

        
        
        
        <Route path='*' element={ <NotFound />} />
        { /*<Route path='/webinar' element={ <Webinar/> } /> */}
      </Routes>
      </RedirectWrapper>
    </Router>
  );
}

export default App;
